/**
 * Action types for company reducer
 */
export default {
    FETCH_INIT: "COMPANY/FETCH_INIT",
    FETCH_SUCCESS: "COMPANY/FETCH_SUCCESS",
    FETCH_ERROR: "COMPANY/FETCH_ERROR"
};
